export default __webpack_public_path__ + "static/media/sleep-icon.94748d3b.svg";